import script from "./es.vue?vue&type=script&lang=js"
export * from "./es.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__